import {ThemedStyleSheet} from '../../Utils/ThemedStyleSheet';
import {Spacing} from '../../Styles';

export default ThemedStyleSheet((theme) => ({
  scrollContent: {
    paddingTop: Spacing.medium,
    paddingBottom: Spacing.large,
  },
  page: {
    flex: 1,
  },
  hero: {
    marginBottom: Spacing.small,
  },
  title: {
    color: theme.colors.textStrong,
    fontSize: 26,
    lineHeight: 32,
    fontWeight: '700',
  },
  subtitle: {
    marginTop: Spacing.xsmall,
    color: theme.colors.textLight,
    lineHeight: 23,
  },
  card: {
    backgroundColor: theme.colors.surface,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    padding: Spacing.small,
    marginBottom: Spacing.small,
  },
  softCard: {
    backgroundColor: theme.colors.surfaceSecondary,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    padding: Spacing.small,
    marginBottom: Spacing.small,
  },
  urgentCard: {
    backgroundColor: theme.colors.urgentSurface,
    borderColor: theme.colors.error,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  body: {
    color: theme.colors.textLight,
    lineHeight: 22,
  },
  strongBody: {
    color: theme.colors.textStrong,
    lineHeight: 23,
  },
  muted: {
    color: theme.colors.textLight,
  },
  button: {
    borderRadius: 8,
    marginTop: Spacing.small,
  },
  buttonGroup: {
    marginTop: Spacing.small,
  },
  secondaryButton: {
    borderRadius: 8,
    marginTop: Spacing.xsmall,
  },
  chipRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: Spacing.small,
  },
  chip: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.xxsmall,
    marginRight: Spacing.xsmall,
    marginBottom: Spacing.xsmall,
    backgroundColor: theme.colors.surface,
  },
  chipSelected: {
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.surfaceSecondary,
    borderWidth: 2,
  },
  chipText: {
    color: theme.colors.textStrong,
  },
  selectionRow: {
    marginTop: Spacing.small,
  },
  selectionCard: {
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    padding: Spacing.small,
    marginTop: Spacing.xsmall,
    backgroundColor: theme.colors.surfaceSecondary,
  },
  selectionCardSelected: {
    borderWidth: 2,
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.surfaceSecondary,
  },
  input: {
    marginTop: Spacing.small,
    backgroundColor: theme.colors.surface,
  },
  footerNote: {
    marginTop: Spacing.small,
    color: theme.colors.textLight,
    lineHeight: 20,
  },
  listItem: {
    marginTop: Spacing.xsmall,
    color: theme.colors.textLight,
    lineHeight: 22,
  },
  warningText: {
    marginTop: Spacing.xsmall,
    color: theme.colors.error,
    lineHeight: 21,
  },
  trendBadge: {
    alignSelf: 'flex-start',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.surfaceSecondary,
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.xxsmall,
    marginTop: Spacing.small,
  },
  trendBadgeWarning: {
    borderColor: theme.colors.error,
    backgroundColor: theme.colors.urgentSurface,
  },
  trendBadgePositive: {
    borderColor: theme.colors.primary,
    backgroundColor: theme.colors.secondary,
  },
  trendBadgeText: {
    color: theme.colors.textStrong,
  },
  hiddenBox: {
    minHeight: 120,
    alignItems: 'center',
    justifyContent: 'center',
  },
  webResultsPage: {
    flex: 1,
    backgroundColor: theme.colors.background,
  },
  webResultsContent: {
    paddingHorizontal: Spacing.pagePadding,
    paddingTop: Spacing.xxsmall,
    paddingBottom: Spacing.large,
  },
  webResultsToggle: {
    alignSelf: 'flex-start',
    paddingVertical: Spacing.xxsmall,
    paddingHorizontal: Spacing.xxsmall,
    marginBottom: Spacing.xsmall,
  },
  webResultsToggleText: {
    color: theme.colors.primary,
    lineHeight: 18,
  },
  webResultCard: {
    backgroundColor: theme.colors.surface,
    borderRadius: 7,
    borderWidth: 1,
    borderColor: theme.colors.border,
    paddingHorizontal: Spacing.small,
    paddingVertical: Spacing.small,
    marginBottom: Spacing.small,
  },
  webResultHeadline: {
    color: theme.colors.textStrong,
    fontWeight: '700',
  },
  webResultSubtitle: {
    marginTop: Spacing.xsmall,
    color: theme.colors.textLight,
  },
  webResultSectionTitle: {
    color: theme.colors.textStrong,
    lineHeight: 22,
    marginBottom: Spacing.xsmall,
  },
  webResultBody: {
    color: theme.colors.textLight,
    lineHeight: 22,
  },
  webResultListItem: {
    color: theme.colors.textLight,
    lineHeight: 23,
    marginTop: Spacing.xxsmall,
  },
  webHiddenBox: {
    minHeight: 130,
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: Spacing.small,
  },
  webResultActions: {
    marginTop: Spacing.medium,
  },
  webPrimaryButton: {
    borderRadius: 7,
    marginBottom: Spacing.xsmall,
  },
  webSecondaryButton: {
    borderRadius: 7,
    borderColor: theme.colors.border,
    backgroundColor: theme.colors.surface,
    marginTop: Spacing.xsmall,
  },
  webButtonContent: {
    minHeight: 40,
  },
  webButtonLabel: {
    fontSize: 14,
    fontWeight: '700',
  },
  webSecondaryButtonLabel: {
    fontSize: 14,
    fontWeight: '700',
    color: theme.colors.primary,
  },
  clinicalResultsContent: {
    width: '100%',
    maxWidth: 680,
    alignSelf: 'center',
    paddingHorizontal: Spacing.pagePadding,
    paddingTop: Spacing.medium,
    paddingBottom: Spacing.xlarge,
  },
  clinicalResultsPage: {
    flex: 1,
    backgroundColor: theme.colors.clinicalPageBackground,
  },
  clinicalResultCard: {
    backgroundColor: theme.colors.surface,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: theme.colors.clinicalCardBorder,
    paddingHorizontal: 18,
    paddingVertical: 18,
    marginBottom: Spacing.small,
    shadowColor: theme.colors.textStrong,
    shadowOffset: {width: 0, height: 2},
    shadowOpacity: 0.06,
    shadowRadius: 5,
    elevation: 2,
  },
  clinicalConditionCard: {
    borderTopWidth: 3,
    borderTopColor: theme.colors.clinicalConditionBorder,
  },
  clinicalCardHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    flexShrink: 1,
  },
  clinicalSectionAccent: {
    width: 4,
    height: 24,
    borderRadius: 2,
    marginRight: Spacing.xsmall,
  },
  clinicalConditionAccent: {
    backgroundColor: theme.colors.clinicalConditionBorder,
  },
  clinicalOverallAccent: {
    backgroundColor: theme.colors.clinicalOverallBorder,
  },
  clinicalNoteAccent: {
    backgroundColor: theme.colors.clinicalNoteBorder,
  },
  clinicalSectionTitle: {
    lineHeight: 23,
    letterSpacing: 0.2,
    flexShrink: 1,
  },
  clinicalConditionTitle: {
    color: theme.colors.clinicalConditionText,
  },
  clinicalIndicatorRow: {
    flexDirection: 'row',
    alignItems: 'center',
    minHeight: 52,
    borderTopWidth: 1,
    borderTopColor: theme.colors.clinicalRowDivider,
    paddingVertical: Spacing.xsmall,
  },
  clinicalIndicatorName: {
    flex: 1,
    color: theme.colors.textStrong,
    lineHeight: 22,
    paddingRight: Spacing.small,
  },
  clinicalIndicatorBadge: {
    minWidth: 92,
    borderRadius: 7,
    paddingHorizontal: Spacing.xsmall,
    paddingVertical: 6,
  },
  clinicalIndicatorModerate: {
    backgroundColor: theme.colors.clinicalModerateSurface,
  },
  clinicalIndicatorMild: {
    backgroundColor: theme.colors.clinicalMildSurface,
  },
  clinicalIndicatorLow: {
    backgroundColor: theme.colors.clinicalLowSurface,
  },
  clinicalIndicatorBadgeText: {
    lineHeight: 18,
  },
  clinicalIndicatorModerateText: {
    color: theme.colors.clinicalModerateText,
  },
  clinicalIndicatorMildText: {
    color: theme.colors.clinicalMildText,
  },
  clinicalIndicatorLowText: {
    color: theme.colors.clinicalLowText,
  },
  clinicalOverallCard: {
    borderTopWidth: 3,
    borderTopColor: theme.colors.clinicalOverallBorder,
  },
  clinicalOverallHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  clinicalOverallHeaderTitle: {
    flex: 1,
  },
  clinicalOverallTitle: {
    color: theme.colors.clinicalOverallText,
  },
  clinicalOverallBadge: {
    flexShrink: 0,
    borderRadius: 7,
    backgroundColor: theme.colors.clinicalOverallSurface,
    paddingHorizontal: Spacing.xsmall,
    paddingVertical: 6,
    marginLeft: Spacing.xsmall,
  },
  clinicalOverallTrack: {
    height: 9,
    borderRadius: 5,
    marginTop: 18,
    overflow: 'hidden',
    backgroundColor: theme.colors.clinicalOverallTrack,
  },
  clinicalOverallFill: {
    height: 9,
    borderRadius: 5,
    backgroundColor: theme.colors.clinicalOverallFill,
  },
  clinicalOverallLabel: {
    color: theme.colors.clinicalOverallText,
    lineHeight: 18,
  },
  clinicalAdvisory: {
    color: theme.colors.textLight,
    lineHeight: 20,
    marginTop: Spacing.small,
  },
  clinicalNoteCard: {
    borderTopWidth: 3,
    borderTopColor: theme.colors.clinicalNoteBorder,
  },
  clinicalNoteTitle: {
    color: theme.colors.clinicalNoteText,
  },
  clinicalNoteBody: {
    color: theme.colors.textStrong,
    lineHeight: 24,
    marginTop: Spacing.small,
    paddingLeft: 12,
    borderLeftWidth: 3,
    borderLeftColor: theme.colors.clinicalNoteSurface,
  },
  clinicalCareButton: {
    width: '100%',
    borderRadius: 10,
    marginTop: Spacing.xsmall,
  },
  clinicalCareButtonContent: {
    minHeight: 54,
  },
  clinicalCareButtonLabel: {
    fontSize: 16,
    fontWeight: '700',
  },
  probabilityRow: {
    marginTop: Spacing.small,
  },
  probabilityTrack: {
    height: 8,
    borderRadius: 4,
    marginTop: Spacing.xxsmall,
    overflow: 'hidden',
    backgroundColor: theme.colors.secondary,
  },
  probabilityFill: {
    height: 8,
    borderRadius: 4,
    backgroundColor: theme.colors.primary,
  },
  timelineItem: {
    borderLeftWidth: 2,
    borderLeftColor: theme.colors.primary,
    paddingLeft: Spacing.small,
    marginTop: Spacing.small,
  },
  link: {
    color: theme.colors.primary,
    textDecorationLine: 'underline',
  },
}));
